import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import './App.css';
import Showcase from './pages/Showcase';
import AppDetail from './pages/AppDetail';
import About from './pages/About';

function App() {
  return (
    <Router>
      <div className="App">
        <AuthenticatedTemplate>
          <Routes>
            <Route path="/" element={<Showcase />} />
            <Route path="/about" element={<About />} />
            <Route path="/app/:appName" element={<AppDetail />} />
          </Routes>
        </AuthenticatedTemplate>
        
        <UnauthenticatedTemplate>
          <div className="login-container">
            <img 
              src="https://cdn.prod.website-files.com/67e26aef79a7047719ea9db8/67e28ceff1544e195a3a2269_astena.svg" 
              alt="Astena Logo" 
              className="login-logo"
            />
          </div>
        </UnauthenticatedTemplate>
      </div>
    </Router>
  );
}

export default App;

